import { FormatVND } from "../../utils/format";
import { Rate, message } from "antd";
import { useDispatch } from "react-redux";
import InputGroup from "../../component/inputGroup";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { buyProduct } from "../../redux/actions/buyProduct";
import { discountPrice } from "../../helper";
import { useDevice } from "../../hooks";
import { BarChartOutlined } from "@ant-design/icons";
import { normalizeMoney, normalizeCount } from "../../utils/productView";

export default function ProductInfor({ product, attribute, isFile }) {
    const { isMobile } = useDevice();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [count, setCount] = useState(0);
    const [select, setSelect] = useState();
    const [showSold, setShowSold] = useState(false);

    const user = JSON.parse(localStorage.getItem("user"));

    // Sach ban Online: tu dong chon loai duy nhat,
    // khach khong can bam "Sach Ban Online" nua.
    useEffect(() => {
        if (isFile && attribute?.[0]) {
            setSelect(attribute[0]);
            setCount(1);
        }
    }, [isFile, attribute]);

    // Check if the current selection is out of stock
    const isOutOfStock = select && Number(select?.total || 0) <= 0;

    const handleButtonClick = (action) => {
        if (isOutOfStock) {
            if (product?.product_link) {
                window.open(product.product_link, '_blank');
            } else {
                message.warning("Sản phẩm hiện đã hết hàng và chưa có link tiếp thị!");
            }
            return;
        }

        if (action === 'cart') addToCard();
        else addToCheckout();
    };


    const addToCard = () => {
        if (user) {
            if (select == undefined) {
                message.warning("Vui lòng chọn loại sản phẩm bạn muốn mua!");
            } else {
                const product_current = {
                    product_id: product?.product_id,
                    product_name: product?.product_name,
                    product_image: product?.product_image,
                    price: product?.product_discount
                        ? discountPrice(
                            product?.product_price,
                            product?.product_discount
                        )
                        : product?.product_price,
                    quantity: count,
                    characteristics: select,
                    totalprice: product.product_discount
                        ? discountPrice(
                            product?.product_price,
                            product?.product_discount
                        ) * count
                        : product?.product_price * count,
                };
                message.success("Thêm sản phẩm vào giỏ hàng thành công!")
                dispatch(
                    buyProduct(
                        product_current
                    )
                );

                window.dispatchEvent(
                    new Event(
                        "cyk-cart-updated"
                    )
                );
            }
        } else {
            message.info("Bạn cần phải đăng nhập để có thể mua hàng!");
            navigate("/dang-nhap");
        }
    }

    const addToCheckout = () => {
        if (user) {
            if (select == undefined) {
                message.warning("Vui lòng chọn loại sản phẩm bạn muốn mua!");
            } else {
                const product_current = {
                    product_id: product?.product_id,
                    product_name: product?.product_name,
                    product_image: product?.product_image,
                    price: product?.product_discount
                        ? discountPrice(
                            product?.product_price,
                            product?.product_discount
                        )
                        : product?.product_price,
                    quantity: count,
                    characteristics: select,
                    totalprice: product.product_discount
                        ? discountPrice(
                            product?.product_price,
                            product?.product_discount
                        ) * count
                        : product?.product_price * count,
                };
                message.success("Thêm sản phẩm vào giỏ hàng thành công!")
                dispatch(
                    buyProduct(
                        product_current
                    )
                );

                window.dispatchEvent(
                    new Event(
                        "cyk-cart-updated"
                    )
                );

                navigate(
                    "/thanh-toan"
                );
            }
        } else {
            message.info("Bạn cần phải đăng nhập để có thể mua hàng!");
            navigate("/dang-nhap");
        }
    }

    const basePrice =
        normalizeMoney(
            product?.product_price
        );

    const discount =
        normalizeMoney(
            product?.product_discount
        );

    const reviewCount =
        normalizeCount(
            product?.comment_count
        );

    const finalPrice =
        discount > 0
            ? basePrice -
              (
                basePrice *
                discount /
                100
              )
            : basePrice;

    return (
        <div className="bg-white p-5 rounded-lg cyk-product-buy-card">
            <h1 className="cyk-product-title">{product?.product_name || "Sản phẩm"}</h1>
            {isMobile ? (
                <div>
                    <div className="flex items-center">
                        <Rate allowHalf defaultValue={product?.comment_rating ? product?.comment_rating : 5} disabled />
                        <div className="flex items-center pl-5 text-gray-700">
                            {showSold ? (
                                <span className="cursor-pointer" onClick={() => setShowSold(false)}>
                                    <span className="font-semibold mr-1">0</span> đã bán
                                </span>
                            ) : (
                                <span className="cursor-pointer text-gray-500 hover:text-gray-700 bg-gray-100 px-2 py-1 rounded text-xs" onClick={() => setShowSold(true)}>
                                    <BarChartOutlined /> Thống kê
                                </span>
                            )}
                        </div>
                    </div>
                    <p className="text-gray-700 pb-5 pt-1"><span className="font-semibold">{reviewCount}</span> Lượt đánh giá</p>
                </div>
            ) : (
                <div className="flex items-center pb-5">
                    <Rate allowHalf defaultValue={product?.comment_rating ? product?.comment_rating : 5} disabled />
                    <p className="border-x px-4 mx-4 text-gray-700"><span className="font-semibold">{reviewCount}</span> Lượt đánh giá</p>
                    <div className="flex items-center text-gray-700">
                        {showSold ? (
                            <span className="cursor-pointer" onClick={() => setShowSold(false)}>
                                <span className="font-semibold mr-1">0</span> đã bán
                            </span>
                        ) : (
                            <span className="cursor-pointer text-gray-500 hover:text-gray-700 bg-gray-100 px-2 py-1 rounded text-xs" onClick={() => setShowSold(true)}>
                                <BarChartOutlined /> Thống kê
                            </span>
                        )}
                    </div>
                </div>
            )}
            <div className="cyk-product-price-wrap">
                <p className="cyk-product-price">
                    {FormatVND(finalPrice)}
                </p>

                {discount > 0 && (
                    <div className="cyk-product-price-meta">
                        <span className="cyk-product-discount">
                            -{discount}%
                        </span>

                        <span className="cyk-product-old-price">
                            {FormatVND(basePrice)}
                        </span>
                    </div>
                )}
            </div>
            <div className="pt-5">
                <div className="flex pt-5">
                    <p className="text-[16px] font-semibold">Loại</p>
                    <p className="pl-2">(Vui lòng kích chọn loại sản phẩm) <span className="text-red-600 font-bold">*</span></p>
                </div>
                {isFile ? (
                    <div className="flex pt-2">
                        <p
                            className={`${select ? "border-2 border-sky-700" : "border border-gray-400"} px-2 py-1 mr-2 cursor-pointer`}
                            onClick={() => { setSelect(attribute?.[0]); setCount(1); }}
                        >
                            Sách Bản Online
                        </p>
                    </div>
                ) : (
                    <div className="flex pt-2">
                        {attribute?.map((_, i) => (
                            <p
                                className={`${select?.characteristics_hash === _?.characteristics_hash ? "border-2 border-sky-700" : "border border-gray-400"} cursor-pointer px-2 py-1 mr-2`}
                                onClick={() => {
                                    if (Number(_?.total || 0) > 0) {
                                        setSelect(_);
                                        setCount(1);
                                    } else {
                                        setSelect(_);
                                        setCount(0);
                                        if (product?.product_link) {
                                            message.info("Sản phẩm hiện đã hết hàng, đang chuyển hướng đến link tiếp thị...");
                                            setTimeout(() => {
                                                window.open(product?.product_link, '_blank');
                                            }, 1000);
                                        } else {
                                            message.warning("Sản phẩm hiện đã hết hàng!");
                                        }
                                    }
                                }}
                            >
                                {_?.values || _?.values_attribute}
                            </p>
                        ))}
                    </div>
                )}
            </div>
            <div className="pt-5">
                <p className="text-[16px] font-semibold">Số lượng</p>
                {isFile ? (
                    <InputGroup
                        count={1}
                        setCount={setCount}
                        onClickButtonMinus={() => {
                            message.info("Bạn đang mua sách bản Online!");
                        }}
                        onClickButtonPlus={() => {
                            message.info("Bạn đang mua sách bản Online!");
                        }}
                    />
                ) : (
                    <InputGroup
                        count={count}
                        setCount={setCount}
                        onClickButtonMinus={() => {
                            if (count > 1) {
                                setCount(count - 1);
                            }
                        }}
                        onClickButtonPlus={() => {
                            if (count < select?.total) {
                                setCount(count + 1);
                            } else {
                                message.info("Số lượng bạn chọn đã lớn hơn số lượng sản phẩm ở trong kho!");
                            }
                        }}
                    />
                )}
            </div>
            <div className="pt-5 flex cyk-product-actions">
                <button
                    type="button"
                    onClick={() => handleButtonClick('cart')}
                    className="cyk-product-btn cyk-product-btn-cart"
                >
                    Thêm vào giỏ
                </button>
                <button
                    type="button"
                    onClick={() => handleButtonClick('checkout')}
                    className={`${isMobile ? "w-[150px]" : "w-[200px]"} text-white bg-[#ff424e] hover:bg-red-600 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium text-[16px] ml-2 py-2 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800`}
                >
                    Mua Ngay
                </button>
            </div>
        </div>
    )
}